import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { gradientColor } from "../../../contants";
// import { AnimationOnScroll } from "react-animation-on-scroll";

export default function Features() {
  const chipsData = [
    {
      img: "/assets/images/best-liquidity.png",
      text: "Best Liquidity",
      heading:
        "Our exchange has super strong liquidity for fast and smooth crypto trading.You can make trades super quick with our exchange's strong liquidity",
    },
    {
      img: "/assets/images/low-fee.png",
      text: "Low Fee",
      heading:
        "We have low fees so you keep more of your crypto money. Our exchange charges small fees so you hold onto more of your investment ",
    },
    {
      img: "/assets/images/safensec.png",
      text: "Safe & Secure",
      heading:
        "Your crypto is very safe and secure with us. We use the multilayer security to keep your crypto protected from hackers.",
    },
    {
      img: "/assets/images/hlpnspt.png",
      text: "24 x 7 Support",
      heading:
        "Our support team helps & fix any problem 24 hours a day. If you have an issue, our support team is always standing by to help you fast.",
    },
  ];

  return (
    <Box className="mainContainer">
      {/* <AnimationOnScroll animateIn="animate__fadeInLeft"> */}
      <Box sx={{ width: "80%", textAlign: "start", marginBottom: "50px" }}>
        <Typography variant="h2">
          <span style={gradientColor}>Relax your assets are secured</span>
        </Typography>
        <Typography variant="h5">
          <span style={gradientColor}>
            Fast trades | Low Fee | Get protected
          </span>
        </Typography>
      </Box>
      {/* </AnimationOnScroll> */}
      {/* <AnimationOnScroll animateIn="animate__fadeInUp"> */}
      <Grid container spacing={2}>
        {chipsData &&
          chipsData.map((item, index) => {
            return (
              <Grid item lg={3} md={6} sm={6} xs={6} key={`row${index}`}>
                <FeatureCard item={item} />
              </Grid>
            );
          })}
      </Grid>
      {/* </AnimationOnScroll> */}
    </Box>
  );
}

const FeatureCard = ({ item }) => {
  return (
    <Box>
      <Box className="displayCenter">
        <img
          src={item.img}
          alt="features"
          width="100%"
          style={{ maxWidth: "200px" }}
        />
      </Box>
      <Box className="displayCenterColumn" textAlign="center" mx="auto">
        <Box className="displayCenterColumn">
          <Typography variant="h6">
            <span style={gradientColor}>{item.text}</span>
          </Typography>
        </Box>
        <Box className="displayCenterColumn" padding="5px">
          <Typography variant="body2">{item.heading}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
